import { createApi } from "@reduxjs/toolkit/query/react";
import fetchBaseQueryCSRF from "../helper";

const conversionsAnalysis = createApi({
  baseQuery: fetchBaseQueryCSRF({ baseUrl: process.env.CROSS_API_URL }),
  reducerPath: 'api.conversionsAnalysis',
  tagTypes: ['conversionsAnalysis'],
  endpoints: (builder) => ({
    getBreakdownChartData: builder.query<any, {
      workspaceId: any,
      start_date: string | null,
      end_date: string | null,
      conversionType: string,
      metric: "Revenue" | "Conversions",
      dimension: "channel" | "country" | "device" | "platform",
      timestep: any,
      devices: any,
      platform: any,
      countries: any
    }>({
      query: ({ workspaceId, start_date, end_date, conversionType, metric, dimension, timestep, countries, platform, devices }) => {
        const url = `/conversionsAnalysis/getBreakdownChartData`;
        const body = {
          workspaceId,
          start_date,
          end_date,
          conversionType,
          metric,
          dimension,
          timestep,
          devices,
          platform,
          countries
        };

        return {
          url,
          method: 'POST',
          body: JSON.stringify(body),
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Accept: 'application/json',
          },
        };
      },
    }),
  }),
});

export const {
  useGetBreakdownChartDataQuery,
} = conversionsAnalysis;

export default conversionsAnalysis;
